import React, { useState, useEffect } from 'react';
import { Layout, Menu, Breadcrumb, Button } from 'antd';
import {
  FileTextOutlined,
  DatabaseOutlined,
  HomeOutlined,
  BankOutlined,
  BookOutlined,
  DollarOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { Routes, Route, useLocation, Link } from 'react-router-dom';

import './App.css';

// Import entity components
import CategoryManagement from './components/CategoryManagement';
import InvoiceManagementTabs from './components/InvoiceManagement';
import MaterialManagement from './components/MaterialManagement';
import RepositoryManagement from './components/RepositoryManagement';
import VoucherCredits from './components/VoucherCredits';
import VoucherDebits from './components/VoucherDebits';
import ClientsAccounts from './components/ClientsAccounts';
import CashboxAccounts from './components/CashboxAccounts';
import SourcesAccounts from './components/SourcesAccounts';
import AccountReport from './components/AccountReport';
import RepositoryReport from './components/RepositoryReport';
import MaterialMovementReport from './components/MaterialMovementReport';

const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

const getMenuName = (key) => {
  const names = {
    clients: 'زبائن',
    cashbox: 'صناديق',
    sources: 'موردون',
    categories: 'فئات',
    materials: 'مواد',
    repositories: 'مستودعات',
    purchases: 'مشتريات',
    sales: 'مبيعات',
    credits: 'دفع',
    debits: 'قبض',
    'account-report': 'تقرير حساب',
    'repository-report': 'تقرير مستودع',
    'material-movement-report': 'تقرير حركة مواد'
  };
  return names[key] || key;
};

function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const getPathKey = (pathname) => {
    const pathToKey = {
      '/': 'clients',
      '/clients': 'clients',
      '/cashbox': 'cashbox',
      '/sources': 'sources',
      '/categories': 'categories',
      '/sales': 'sales',
      '/purchases': 'purchases',
      '/materials': 'materials',
      '/repositories': 'repositories',
      '/credits': 'credits',
      '/debits': 'debits',
      '/account-report': 'account-report',
      '/repository-report': 'repository-report',
      '/material-movement-report': 'material-movement-report'
    };
    return pathToKey[pathname] || 'clients';
  };

  const currentKey = getPathKey(location.pathname);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        breakpoint="lg"
        collapsedWidth={isMobile ? 0 : 80}
        trigger={null}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          right: isMobile && collapsed ? -200 : 0,
          top: 0,
          bottom: 0,
          transition: 'right 0.2s',
          zIndex: 1000,
        }}
        width={200}
      >
        <div className="logo" style={{ height: '32px', margin: '16px', background: 'rgba(255, 255, 255, 0.3)' }} />
        <Menu theme="dark" selectedKeys={[currentKey]} mode="inline" className="custom-nav-menu">
          <SubMenu key="general" icon={<GlobalOutlined />} title="عام">
            <SubMenu key="accounts" icon={<BankOutlined />} title="حسابات">
              <Menu.Item key="clients">
                <Link to="/clients">زبائن</Link>
              </Menu.Item>
              <Menu.Item key="cashbox">
                <Link to="/cashbox">صناديق</Link>
              </Menu.Item>
              <Menu.Item key="sources">
                <Link to="/sources">موردون</Link>
              </Menu.Item>
            </SubMenu>
            <Menu.Item key="categories" icon={<BookOutlined />}>
              <Link to="/categories">فئات</Link>
            </Menu.Item>
            <Menu.Item key="materials" icon={<DatabaseOutlined />}>
              <Link to="/materials">مواد</Link>
            </Menu.Item>
            <Menu.Item key="repositories" icon={<HomeOutlined />}>
              <Link to="/repositories">مستودعات</Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="invoices" icon={<FileTextOutlined />} title="فواتير">
            <Menu.Item key="sales" icon={<FileTextOutlined />}>
              <Link to="/sales">مبيعات</Link>
            </Menu.Item>
            <Menu.Item key="purchases" icon={<FileTextOutlined />}>
              <Link to="/purchases">مشتريات</Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="vouchers" icon={<DollarOutlined />} title="سندات">
            <Menu.Item key="credits">
              <Link to="/credits">دفع</Link>
            </Menu.Item>
            <Menu.Item key="debits">
              <Link to="/debits">قبض</Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="reports" icon={<FileTextOutlined />} title="تقارير">
            <Menu.Item key="account-report">
              <Link to="/account-report">تقرير حساب</Link>
            </Menu.Item>
            <Menu.Item key="repository-report">
              <Link to="/repository-report">تقرير مستودع</Link>
            </Menu.Item>
            <Menu.Item key="material-movement-report">
              <Link to="/material-movement-report">تقرير حركة مواد</Link>
            </Menu.Item>
          </SubMenu>
        </Menu>
      </Sider>
      <Layout className="site-layout" style={{ marginRight: isMobile ? 0 : collapsed ? 80 : 200, transition: 'margin-right 0.2s' }}>
        <Header className="site-layout-background" style={{ padding: '0 16px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={toggleSidebar}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
        </Header>
        <Content style={{ margin: isMobile ? '8px' : '0 16px' }}>
          <Breadcrumb style={{ margin: isMobile ? '8px 0' : '16px 0' }}>
            <Breadcrumb.Item>محاسب</Breadcrumb.Item>
            <Breadcrumb.Item>{getMenuName(currentKey)}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="site-layout-background" style={{ padding: isMobile ? 12 : 24, minHeight: 360 }}>
            <Routes>
              <Route path="/" element={<ClientsAccounts />} />
              <Route path="/clients" element={<ClientsAccounts />} />
              <Route path="/cashbox" element={<CashboxAccounts />} />
              <Route path="/sources" element={<SourcesAccounts />} />
              <Route path="/categories" element={<CategoryManagement />} />
              <Route path="/sales" element={<InvoiceManagementTabs mode="sale" />} />
              <Route path="/purchases" element={<InvoiceManagementTabs mode="purchase" />} />
              <Route path="/materials" element={<MaterialManagement />} />
              <Route path="/repositories" element={<RepositoryManagement />} />
              <Route path="/credits" element={<VoucherCredits />} />
              <Route path="/debits" element={<VoucherDebits />} />
              <Route path="/account-report" element={<AccountReport />} />
              <Route path="/repository-report" element={<RepositoryReport />} />
              <Route path="/material-movement-report" element={<MaterialMovementReport />} />
            </Routes>
          </div>
        </Content>
      </Layout>
      {isMobile && !collapsed && (
        <div 
          className="mobile-overlay"
          onClick={() => setCollapsed(true)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.45)',
            zIndex: 999,
          }}
        />
      )}
    </Layout>
  );
}

export default App;

